
import './utils/rem.js'
import Vue from 'vue'
import Home from './views/Home.vue'
import router from "./router";
import store from './store';
import App from "./App.vue";
import xmlog from "./utils/log";// eslint-disable-line


import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard);
Vue.config.productionTip = false
Vue.prototype.$xmlog = xmlog;
Vue.prototype.$router2 = router

new Vue({
    store,
    router,
    render: h => h(App),
  }).$mount('#app');
